import React from 'react';
import { Wrapper, Heading, Content, TopIcon, Tnc, ImageWrapper } from './styles';

const Popup1 = () => (
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon6.png`} alt="" width="100" />
    </TopIcon>
    <Heading>音源資訊  格式數據盡現</Heading>
    <br />
    <hr />
    <Content>
    MOOV 音樂播放器顯示詳盡音樂資訊<sup>#</sup>，深度呈現格式及數據資料（位元度、取樣頻率、音頻格式、版本、位元率及檔案大小）。匠心設計最在地的用戶體驗與操作介面，音樂資訊一目了然。MOOV 提供 24 bit 音質之餘，仍會提供16 bit 、320 kbps 及 128 kbps 音質。無論是使用流動網絡或 WiFi上網，你都可按需要設定音質，選擇你的心水音樂版本。
    <br />
    <br />
    <ImageWrapper>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/app_setting.jpg`} alt="" width="100%" />
    </ImageWrapper>
    <br />
    <Tnc>#根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV擁有香港最大 24 bit FLAC 無損串流音樂庫提供 24 bit FLAC 無損音樂庫及音源資訊包括位元度、取樣頻率、音頻格式、版本及位元率之音樂串流平台。</Tnc>
    </Content>
  </Wrapper>
)

export default Popup1;